
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import EcobonusCheckDialog from '@/components/EcobonusCheckDialog.vue';
import EcobonusCheckResetDialog from '@/components/EcobonusCheckResetDialog.vue';
import AttachmentsList from '@/components/AttachmentsList.vue';
import {
  Lead, LeadStatus, PermissionCode, Task,
} from '@/types';

moment.locale('it');

@Component({
  components: {
    EcobonusCheckDialog,
    EcobonusCheckResetDialog,
    AttachmentsList,
  },
})
export default class EcobonusCheck extends Vue {
  @Prop(Object) readonly task: Task | undefined

  ecDialog = false

  ecResetDialog = false

  loading = false

  get user() {
    return this.$store.getters.currentUser;
  }

  get isSuperUser() {
    return this.user && this.user.isSuperUser;
  }

  get userPermissions() {
    return this.$store.getters.currentUserPermissions;
  }

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  get status(): LeadStatus {
    return this.lead.status;
  }

  get open(): boolean {
    return this.lead && this.status === 'open';
  }

  get closed(): boolean {
    return this.lead && this.status === 'closed';
  }

  get hasCategories() {
    return this.lead && typeof this.lead.flatCategories === 'string' && this.lead.flatCategories.length > 2;
  }

  get ecobonusIntegration() {
    return this.$store.getters.getIntegrations.ecobonusCheck;
  }

  get isEcobonusCheckEnabled() {
    // L'integrazione e' spenta e non verra' riaccesa. Il controllo sul
    // permesso non basta: i Super Utenti lo scavalcano, e nei dati importati
    // il permesso e' assegnato a un gruppo di utenti veri.
    if (!this.ecobonusIntegration.enabled) return false;
    if (
      !this.hasPermission('leads.ecobonuscheck')
      || !this.lead
      || !this.hasCategories) return false;

    return this.lead.flatCategories
      && (
        this.lead.flatCategories.includes(':15:')
        || this.lead.flatCategories.includes(':21:')
        || this.lead.flatCategories.includes(':22:')
        || this.lead.flatCategories.includes(':23:')
      );
  }

  get isEcobonusCheckDone() {
    if (!this.lead) return false;

    return this.lead.ecCompletedAt !== null;
  }

  get ecobonusCheckResult() {
    if (!this.lead || !this.lead.ecResult) return null;

    return JSON.parse(this.lead.ecResult);
  }

  hasPermission(codename: PermissionCode): boolean {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  onReset() {
    this.ecResetDialog = true;
  }

  onStart(id = null) {
    // Indirizzo dal backend. Quello cablato conteneva nome e identificativo di
    // account del cliente precedente, quindi portava dentro il suo spazio.
    const base = this.ecobonusIntegration.url;
    if (!base) return;

    const url = id
      ? `${base}/${this.lead.id}/${this.user.name}/${id}`
      : `${base}/${this.lead.id}/${this.user.name}`;

    window.location.href = encodeURI(url);
  }

  onEcobonusCheck() {
    this.ecDialog = true;
  }

  mDateTime(date: Date): string {
    return `${moment(date).format('L')} ore ${moment(date).format('LT')}`;
  }
}
